const ITEMS = [
  "南方多城强降雨仍在持续，应急部门持续抢险跟进",
  "大型音乐节加场扩容，明日门票基本售罄",
  "省级篮球联赛加时绝杀，直播观看创纪录",
  "国产开源框架一夜爆红，官方连夜更新教程",
  "经典亲子综艺重启录制，阵容话题冲上热榜",
  "多地音乐节扎堆开唱，周末现场人气走高",
  "夜市小吃摊主走红，网友排队三小时求打卡",
];

export default function Ticker() {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <section className="bg-foreground-950 text-background-50" aria-label="滚动快讯">
      <div className="mx-auto flex max-w-7xl items-center gap-3 overflow-hidden px-4 py-2 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-2.5 py-0.5 text-xs font-medium text-background-50">
          <i className="ri-flashlight-line text-sm" aria-hidden="true" />
          快讯
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track">
            {doubled.map((t, i) => (
              <span key={i} className="mx-6 inline-flex items-center gap-2 text-sm text-background-100">
                <i className="ri-circle-fill text-[5px] text-accent-400" aria-hidden="true" />
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}